module.exports = __webpack_public_path__ + "img/moulding.77d3bce7.svg";